import Dispatcher from 'search/Dispatcher';
import { ActionTypes } from 'search/constants';
import { EventEmitter } from 'events';
import invariant from 'invariant';
import has from 'lodash/has';

const CHANGE_EVENT = 'change';
let _results;
let _pendingRequestTimestamps;
let _currentResultsTimestamp;
let _activeResultId;

// Exported only for tests
export function __resetInternalState() {
  _results = { venues: [], meta: {} };
  _pendingRequestTimestamps = [];
  _currentResultsTimestamp = -1;
  _activeResultId = -1;
}
__resetInternalState();

const SearchResultsStore = Object.assign({}, EventEmitter.prototype, {
  emitChange() {
    this.emit(CHANGE_EVENT);
  },

  /**
   * @param {function} callback
   */
  addChangeListener(callback) {
    this.on(CHANGE_EVENT, callback);
  },

  /**
   * @param {function} callback
   */
  removeChangeListener(callback) {
    this.removeListener(CHANGE_EVENT, callback);
  },

  get() {
    return _results;
  },

  isLoading() {
    return _pendingRequestTimestamps.length > 0;
  },

  activeResultId() {
    return _activeResultId;
  }
});

SearchResultsStore.dispatchToken = Dispatcher.register(payload => {
  const action = payload.action;

  switch (action.type) {
    case ActionTypes.SET_INITIAL_RESULTS:
      _results = action.initialResults;
      SearchResultsStore.emitChange();
      break;
    case ActionTypes.FETCH_RESULTS_START:
      _pendingRequestTimestamps.push(action.timestamp);
      SearchResultsStore.emitChange();
      break;
    case ActionTypes.FETCH_RESULTS_SUCCESS:
      if (action.timestamp > _currentResultsTimestamp) {
        _pendingRequestTimestamps = _pendingRequestTimestamps.filter(
          timestamp => {
            return timestamp > action.timestamp;
          }
        );
        _results = action.rawResults;
        _currentResultsTimestamp = action.timestamp;
        SearchResultsStore.emitChange();
      }
      break;
    case ActionTypes.FETCH_RESULTS_FAILURE:
      _pendingRequestTimestamps.shift();
      SearchResultsStore.emitChange();
      break;
    case ActionTypes.FOCUS_SEARCH_RESULT:
      _activeResultId = action.id;
      SearchResultsStore.emitChange();
      break;
    default:
    // no-op
  }

  if (__DEV__) {
    invariant(
      has(_results, 'venues') && has(_results, 'meta'),
      'Expected search results to be an object with `venues` and `meta` keys, got: %s',
      JSON.stringify(_results)
    );
  }
});

export default SearchResultsStore;

// Helpers for testing only!
export function __setStoredResults(results) {
  _results = results;
}
